import type { FC, ChangeEventHandler } from 'react'

import Checkbox from './Checkbox'
import TooltipIcon from './IconGroup/TooltipIcon'

interface Props {
  label: string
  disabled: boolean
  disabledTooltip: string
  checked: boolean
  onChange: ChangeEventHandler<HTMLInputElement>
}

const CheckboxWithDisabledTooltip: FC<Props> = ({
  label,
  disabled,
  disabledTooltip,
  checked,
  onChange,
}) =>
  disabled ? (
    <TooltipIcon
      tooltipMessage={disabledTooltip}
      icon={<Checkbox label={label} checked={checked} disabled onChange={onChange} />}
    />
  ) : (
    <Checkbox label={label} checked={checked} onChange={onChange} />
  )

export default CheckboxWithDisabledTooltip
